module.exports = __webpack_public_path__ + "kyperson/pcweb/res/img/logo.5e27ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 101